import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import PROPTYPES from '../../../lib/propTypes'
import Select from 'react-select'
import './ClientsView.scss'

class ClientsView extends React.Component {
  static defaultProps = {
    clients: [],
    getClients: _.noop,
    createClient: _.noop,
    setClientVersion: _.noop,
    createdClient: null,
    updatedClient: null,
  }

  static propTypes = {
    getClients: PropTypes.func,
    setClientVersion: PropTypes.func,
    createClient: PropTypes.func,
    clients: PropTypes.object,
    createdClient: PROPTYPES.updatedInterfaceVersion,
    updatedClient: PROPTYPES.updatedInterfaceVersion,
    ui: PropTypes.shape({
      isFetchingClients: PropTypes.bool,
      isCreatingClient: PropTypes.bool,
      isUpdatingClient: PropTypes.bool,
    }),
  }

  constructor (props) {
    super(props)
    this.state = {
      createInput: '',
      selectedVersions: {},
      versionInputs: {},
      versionDetailInputs: {},
    }
  }

  componentDidMount () {
    this.props.getClients()
  }

  onFieldChange = (fieldName, value) => {
    this.setState({
      [fieldName]: value
    })
  }

  handleCreateClient = () => {
    const { createClient } = this.props
    const { createInput } = this.state

    return createClient(createInput).then(() => {
      this.setState({
        createInput: ''
      })
    })
  }

  handleSelect = (clientName, selected) => {
    const { selectedVersions } = this.state
    if (selected == null) {
      selected = ''
    }
    this.setState({
      selectedVersions: {
        ...selectedVersions,
        [clientName]: selected
      }
    })
  }

  handleInput = (clientName, input) => {
    const { versionInputs } = this.state
    this.setState({
      versionInputs: {
        ...versionInputs,
        [clientName]: input
      }
    })
  }

  handleDetailInput = (clientName, event) => {
    const { versionDetailInputs } = this.state
    this.setState({
      versionDetailInputs: {
        ...versionDetailInputs,
        [clientName]: event.target.value
      }
    })
  }

  handleCreateVersion = (clientName) => {
    const { versionInputs, versionDetailInputs } = this.state
    const { setClientVersion } = this.props
    return setClientVersion(clientName, versionInputs[clientName], versionDetailInputs[clientName]).then(() => {
      this.setState({
        versionInputs: {
          ...versionInputs,
          [clientName]: '',
        },
        versionDetailInputs: {
          ...versionDetailInputs,
          [clientName]: '',
        }
      })
    })
  }

  handleSetVersion = (clientName) => {
    const { selectedVersions } = this.state
    const { setClientVersion } = this.props
    return setClientVersion(clientName, selectedVersions[clientName].version).then(() => {
      this.setState({
        selectedVersions: {
          ...selectedVersions,
          [clientName]: '',
        }
      })
    })
  }

  render () {
    const { clients, ui } = this.props
    const { createInput, selectedVersions, versionDetailInputs } = this.state
    const tableRows = _.map(clients, (client) => {
      let options = client.version_history.map((option) => {
        return {
          ...option,
          label: `${option.version} ${option.details ? `- ${option.details}` : ''}`
        }
      })
      return (
        <div key={client.name} className='table-row'>
          <div className='table-cell client-name'>{client.name}</div>
          <div className='table-cell current-version'>{client.current_version}</div>
          <div className='table-cell details'>
            <input
              className='version-input'
              type='text'
              value={versionDetailInputs[client.name]}
              onChange={(event) => this.handleDetailInput(client.name, event)}
              disabled={selectedVersions[client.name]}
            />
          </div>
          <div className='table-cell version-select'>
            <Select
              className='version-input'
              isSearchable
              isClearable
              isLoading={ui.isFetchingClients}
              options={options}
              value={selectedVersions[client.name]}
              onChange={(selected) => this.handleSelect(client.name, selected)}
              onInputChange={(input) => this.handleInput(client.name, input)}
              onBlurResetsInput={false}
              onCloseResetsInput={false}
              noResultsText={false}
              labelKey={'label'}
              valueKey={'version'}
              placeholder={'x.x.x'}
            />
          </div>
          <div className='table-cell action'>
            {
              selectedVersions[client.name]
              ? <button onClick={() => this.handleSetVersion(client.name)}>Set Version</button>
              : <button onClick={() => this.handleCreateVersion(client.name)}>Create Version</button>
            }
          </div>
        </div>
      )
    })
    return (
      <div className='clients-view'>
        <div>
          <input
            className='create-input'
            type='text'
            placeholder='client-name-to-create'
            value={createInput}
            onChange={(e) => this.onFieldChange('createInput', e.target.value)} />
          <button
            className='create-button'
            onClick={this.handleCreateClient}
          >
            Create Client
          </button>
        </div>
        <div className='client-table'>
          <div className='table-header'>
            <div className='header client-name'> Client </div>
            <div className='header current-version'> Current Version </div>
            <div className='header details'> Details <div>(Must be in form "VERSION - DESCRIPTION")</div> </div>
            <div className='header version-select'> Set Version </div>
            <div className='header action'> </div>
          </div>
          <div className='table-body'>
            {tableRows}
          </div>
        </div>
      </div>
    )
  }
}

export default ClientsView



// WEBPACK FOOTER //
// ./src/routes/Clients/components/ClientsView.jsx